import { REPORT_LIST_FILTERS, type ReportFilterState, type ReportListFilter } from '../Contracts/Report'
import { defaultPeriod } from './reportPeriod'

/** Порожні списки для всіх фільтрів-довідників */
const emptyLists = (): Record<ReportListFilter, []> =>
    Object.fromEntries(REPORT_LIST_FILTERS.map((name) => [name, []])) as unknown as Record<ReportListFilter, []>

/** Початковий стан фільтрів: поточний місяць, усі задачі */
export const initialReportFilters = (): ReportFilterState => ({
    period: defaultPeriod(),
    source: 'all',
    isHired: 'all',
    lists: emptyLists(),
})

/**
 * Query-параметри API звітів (формат ReportFilter на бекенді): дати `YYYY-MM-DD`,
 * списки — id через кому; значення «усі» не передаються.
 */
export const buildReportParams = (state: ReportFilterState): Record<string, string> => {
    const params: Record<string, string> = {}
    if (state.period) {
        params['from'] = state.period[0].format('YYYY-MM-DD')
        params['to'] = state.period[1].format('YYYY-MM-DD')
    }
    if (state.source !== 'all') params['source'] = state.source
    if (state.isHired !== 'all') params['isHired'] = state.isHired
    REPORT_LIST_FILTERS.forEach((name) => {
        const ids = state.lists[name].map((option) => option.value)
        if (ids.length > 0) params[name] = ids.join(',')
    })
    return params
}

/** Фільтри з блоку «Ще фільтри» */
export const EXTRA_LIST_FILTERS: ReportListFilter[] = [
    'vehicleType',
    'cargo',
    'constructionObject',
    'loadingPoint',
    'unloadingPoint',
    'typicalRoute',
    'dispatcher',
]

/** Скільки фільтрів з блоку «Ще фільтри» задано (для лічильника на кнопці) */
export const countExtraFilters = (state: ReportFilterState): number =>
    EXTRA_LIST_FILTERS.filter((name) => state.lists[name].length > 0).length + (state.isHired !== 'all' ? 1 : 0)
